import { EventEmitter } from 'eventemitter3';
export class ProviderEventEmitter extends EventEmitter {
}
//# sourceMappingURL=interface.js.map